import { z } from "zod";
export var Granularity;
(function (Granularity) {
    Granularity["NONE"] = "none";
    Granularity["DAY"] = "day";
    Granularity["WEEK"] = "week";
    Granularity["MONTH"] = "month";
    Granularity["QUARTER"] = "quarter";
    Granularity["YEAR"] = "year";
})(Granularity || (Granularity = {}));
export var BooleanString;
(function (BooleanString) {
    BooleanString["TRUE"] = "true";
    BooleanString["FALSE"] = "false";
})(BooleanString || (BooleanString = {}));
export const zodWithStartAndEndTime = z.object({
    startTimeISO: z.string(),
    endTimeISO: z.string(),
});
export function generateURLParameters(params) {
    const updatedParams = new URLSearchParams();
    Object.keys(params).forEach((key) => {
        if (params[key]) {
            if (Array.isArray(params[key])) {
                params[key].forEach((el) => {
                    updatedParams.append(key, el);
                });
            }
            else {
                updatedParams.append(key, params[key]);
            }
        }
    });
    return updatedParams.toString();
}
//# sourceMappingURL=common.js.map